import { IComponentOptions } from 'angular';
import { GradPlanningWizardDropdownCtrl } from './grad-planning-wizard-dropdown.controller';

export const GradPlanningWizardDropdownComponent: IComponentOptions = {
  bindings: {
    //
  },
  controller: GradPlanningWizardDropdownCtrl,
  template: require('./grad-planning-wizard-dropdown.html'),
};
